/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import {Injectable} from '@angular/core';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {HttpClient} from '@angular/common/http';
import {RestResponse, Report} from '../model';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';

@Injectable()
export class SideNoteProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getSearchType(): string {
    return 'SIDE_NOTE';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .put<RestResponse>(`${environment.API_URL}/api/notes/${id}/field`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getSideNotes();
  }

  create(report?: Report): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/notes`,{
        FIELD: "ID",
        VALUE: report ? report.ID : null
      }, ApiHeaders.getOptions());
  }

  getSideNotes(): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/notes/list`,
        ApiHeaders.getOptions());
  }

  deleteById(id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/notes/${id}`, ApiHeaders.getOptions());
  }

  reorder(id: string, sid: string): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/notes/${id}/reorder/${sid}`, ApiHeaders.getOptions());
  }
}
